export const downloadFromUrl = async (
  url: string,
  signal?: AbortSignal,
): Promise<void> => {
  const response = await fetch(url, { signal });

  if (!response.ok) {
    throw new Error("Failed to download file");
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = "media-library.zip";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
};
